import { Appear, Flex, Text } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';
import useFilters from '../Filters/useFilters';

const MessageEmptyData: FunctionComponent<{ empty: boolean; help?: boolean }> = (props) => {
  const { empty, help } = props;
  const { filters } = useFilters();

  return (
    <Appear
      absolute
      animation="Fade"
      style={{ pointerEvents: empty ? undefined : 'none' }}
      visible={empty}
    >
      <Flex alignChildren="middle" direction="vertical" height="100%">
        <Flex paddingHorizontal="x4" textColor="gray-7">
          <Text align="middle" size="x2">
            No data for this metric.
          </Text>

          {help && (
            <Text align="middle" size="x2">
              Try adjusting the{' '}
              {filters.length > 0 && (
                <>
                  <Text breakOn="none" inline textColor="grape-3">
                    Session Filters
                  </Text>{' '}
                  or
                </>
              )}{' '}
              <Text breakOn="none" inline textColor="grape-3">
                Date Range
              </Text>
              .
            </Text>
          )}
        </Flex>
      </Flex>
    </Appear>
  );
};

export default MessageEmptyData;
